import { render, staticRenderFns } from "./InternalTransfer.vue?vue&type=template&id=b765846e&"
import script from "./InternalTransfer.vue?vue&type=script&lang=js&"
export * from "./InternalTransfer.vue?vue&type=script&lang=js&"
import style0 from "./InternalTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports